import { useEffect } from "react";

const Snackbar = ({ message, type = "error", onClose, duration = 4000 }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);
    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const colors = {
    error: "bg-red-500",
    success: "bg-green-500",
    warning: "bg-yellow-500",
    info: "bg-blue-500",
  };

  return (
    <div className={`fixed bottom-4 left-4 z-50`}>
      <div
        className={`text-white px-4 py-3 rounded shadow-lg ${colors[type]} min-w-[200px]`}
      >
        {message}
      </div>
    </div>
  );
};

export default Snackbar;
